<div style="border: 1px solid #d9d9d9; border-radius: 4px; padding: 16px; width: 100%; margin-top: 8px;">
  <p>Select the recipients for this message:</p>
  <!-- Franchises Select -->
  <div style="margin-bottom: 16px;">
    <label style="display: block; margin-bottom: 4px; font-weight: 500;">
      Franchises
    </label>
    <nz-select
      style="width: 100%;"
      nzMode="multiple"
      [ngModel]="selectedFranchises()"
      (ngModelChange)="onFranchiseChange($event)"
      nzPlaceHolder="Select franchises"
      [nzAllowClear]="true">
      <ng-container *ngIf="availableRecipients.franchises?.length; else loadingFranchises">
        <nz-option [nzValue]="-1" nzLabel="All Franchises"></nz-option>
        <nz-option *ngFor="let franchise of availableRecipients.franchises"
                   [nzValue]="franchise.id"
                   [nzLabel]="franchise.name">
        </nz-option>
      </ng-container>
      <ng-template #loadingFranchises>
        <nz-option nzCustomContent>
          <nz-spin nzTip="Loading franchises..." style="width: 100%; display: block;"></nz-spin>
        </nz-option>
      </ng-template>
    </nz-select>
  </div>

  <!-- Clients Select -->
  <div style="margin-bottom: 16px;">
    <label style="display: block; margin-bottom: 4px; font-weight: 500;">
      Branches
    </label>
    <nz-select 
      style="width: 100%;"
      nzMode="multiple"
      [(ngModel)]="messageConfig.clientIds"
      (ngModelChange)="onClientChange($event)"
      nzPlaceHolder="Select branches"
      [nzAllowClear]="true">
      <ng-container *ngIf="filteredClients()?.length; else loadingClients">
        <nz-option [nzValue]="-1" nzLabel="All Branches"></nz-option>
        <nz-option *ngFor="let client of filteredClients()" 
                   [nzValue]="client.id" 
                   [nzLabel]="client.name">
        </nz-option>
      </ng-container>
      <ng-template #loadingClients>
        <nz-option nzCustomContent>
          <nz-spin nzTip="Loading branches..." style="width: 100%; display: block;"></nz-spin>
        </nz-option>
      </ng-template>
    </nz-select>
  </div>

  <!-- Roles Select -->
  <div>
    <label style="display: block; margin-bottom: 4px; font-weight: 500;">
      Roles
    </label>
    <nz-select 
      style="width: 100%;"
      nzMode="multiple"
      [(ngModel)]="messageConfig.roleIds"
      (ngModelChange)="onRoleChange($event)"
      nzPlaceHolder="Select roles"
      [nzAllowClear]="true">
      <ng-container *ngIf="availableRecipients.roles?.length; else loadingRoles">
        <nz-option [nzValue]="-1" nzLabel="All Roles"></nz-option>
        <nz-option *ngFor="let role of availableRecipients.roles" 
                   [nzValue]="role.id" 
                   [nzLabel]="role.name">
        </nz-option>
      </ng-container>
      <ng-template #loadingRoles>
        <nz-option nzCustomContent>
          <nz-spin nzTip="Loading roles..." style="width: 100%; display: block;"></nz-spin>
        </nz-option>
      </ng-template>
    </nz-select>
  </div>

</div>